export const toBrowserTimezoneAndFormat = (timestamp) => {
  let offset = new Date().getTimezoneOffset()
  let date = new Date(timestamp)
  return new Date(date - offset * 60000).toLocaleString()
}
